export default "__VITE_ASSET__DCBkgvKM__"